import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  removeImage: function (file, path) {
    return axios.post(`${window.apiURL}api/upload/remove-image`, { file, path })
  },
  uploadSong: function (filename, file, onProgress) {
    let formData = new FormData()

    formData.append('filename', filename)
    formData.append('file', file)

    return axios.post(`${window.apiURL}api/upload-distribution-song`, formData, { onUploadProgress: onProgress }).then((response) => {
      formData.delete('file')

      return response
    })
  },
  uploadMastering: function (filename, file, onProgress, _id) {
    let formData = new FormData()

    formData.append('filename', filename)
    formData.append('file', file)
    formData.append('_id', _id)

    return axios.post(`${window.apiURL}api/upload-mastering`, formData, { onUploadProgress: onProgress }).then((response) => {
      formData.delete('file')

      return response
    })
  },
  uploadLyricVideoSong: function (filename, file, onProgress) {
    let formData = new FormData()

    formData.append('filename', filename)
    formData.append('file', file)

    return axios.post(`${window.apiURL}api/upload-distribution-song`, formData, { onUploadProgress: onProgress }).then((response) => {
      formData.delete('file')
      return response
    })
  },
  uploadVideo: function (file, onProgress) {
    let formData = new FormData()
    let fileName = `${new Date().getTime()}.${file.name.split('.').pop()}`
    formData.append('filename', fileName)
    formData.append('file', file)
    formData.append('path', 'spotify-video-campaigns')

    return axios.post(`${window.apiURL}api/upload/video`, formData, { onUploadProgress: onProgress })
  },
  uploadLicense: function (file, onProgress) {
    let formData = new FormData()
    let fileName = `${new Date().getTime()}.${file.name.split('.').pop()}`
    formData.append('filename', fileName)
    formData.append('file', file)
    formData.append('path', 'distro-licenses')

    return axios.post(`${window.apiURL}api/upload-license`, formData, { onUploadProgress: onProgress })
  },
  uploadFormFile: function (file, onProgress) {
    let formData = new FormData()
    let fileName = `${new Date().getTime()}.${file.name.split('.').pop()}`
    formData.append('filename', fileName)
    formData.append('file', file)
    formData.append('path', 'form-files')

    return axios.post(`${window.apiURL}api/upload-license`, formData, { onUploadProgress: onProgress })
  },
  removeLicense: function (fileName) {
    fileName = fileName.split('/').pop()
    let formData = new FormData()
    formData.append('fileName', fileName)
    formData.append('path', 'distro-licenses')

    return axios.post(`${window.apiURL}api/remove-license`, formData)
  },
  uploadImage: function (file, path, filename, target, id) {
    filename = filename || `${new Date().getTime()}.jpg`

    if (!file) {
      return
    }

    const formData = new FormData()
    formData.append('filename', filename)
    formData.append('file', file)

    if (target) {
      formData.append('target', target)
    }

    if (id) {
      formData.append('id', id)
    }

    if (path) {
      formData.append('path', path)
    }

    if (this.coverImage) {
      formData.append('replace', this.coverImage.split('/').pop())
    }

    return axios.post(`${window.apiURL}api/upload-image`, formData)
  },
  removeSong: function (file, path) {
    return axios.post(`${window.apiURL}api/upload/remove-song-file`, { file, path })
  }
}



// WEBPACK FOOTER //
// ./src/services/upload.js